// ====================================================================================
// swiper.module
// ====================================================================================
import Swiper from "swiper";
import {
  Navigation,
  A11y,
  Keyboard,
  Pagination,
  Scrollbar,
} from "swiper/modules";

import "swiper/swiper-bundle.min.css";

// ====================================================================================
// CSS - Integrate directly into html
// ====================================================================================

export const init = function () {
  let swiperContainers = document.querySelectorAll(".swiper-container");

  swiperContainers.forEach(function (swiperContainer) {
    let cID = swiperContainer.id;
    let id = swiperContainer.querySelector(".swiper").id;

    let tlSlider;
    if (swiperContainer.classList.contains("teasers-slider__container")) {
      tlSlider = new Swiper("#" + id, {
        modules: [Navigation, Keyboard, A11y, Pagination, Scrollbar],
        keyboard: { enabled: true },
        a11y: { enabled: true },
        slidesPerView: 1.1,
        spaceBetween: 20,
        pagination: {
          el: `#${cID} .swiper-pagination`,
          enabled: false,
          clickable: true,
        },
        navigation: {
          nextEl: `#${cID} .swiper-button-next`,
          prevEl: `#${cID} .swiper-button-prev`,
          enabled: false,
        },
        scrollbar: {
          el: `#${cID} .swiper-scrollbar`,
          hide: false,
          draggable: true,
          dragSize: 100,
        },
        breakpoints: {
          480: {
            slidesPerView: 1.105,
            spaceBetween: 20,
          },
          768: {
            navigation: {
              enabled: true,
            },
            slidesPerView: 1.6,
            spaceBetween: 30,
          },
          992: {
            navigation: {
              enabled: true,
            },
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
        on: {
          afterInit: function () {
            swiperContainer.classList.add("slider-init");
            checkScrollbarVisibility(this, swiperContainer);
            const swiperElement = this.el;
            const nextButton = swiperContainer.querySelector(
              ".swiper-button-next"
            );
            const tabindexValue = nextButton.getAttribute("tabindex");
            if (tabindexValue == -1) {
              swiperElement.classList.add("reachEnd");
            } else {
              swiperElement.classList.remove("reachEnd");
            }
          },
          progress: function () {
            const swiperElement = this.el;
            const nextButton = swiperContainer.querySelector(
              ".swiper-button-next"
            );
            const tabindexValue = nextButton.getAttribute("tabindex");
            if (tabindexValue == -1) {
              swiperElement.classList.add("reachEnd");
            } else {
              swiperElement.classList.remove("reachEnd");
            }
          },
        },
      });
    } else if (swiperContainer.classList.contains("quotes-slider__container")) {
      tlSlider = new Swiper("#" + id, {
        modules: [Navigation, Keyboard, A11y, Pagination, Scrollbar],
        keyboard: { enabled: true },
        a11y: { enabled: true },
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: `#${cID} .swiper-pagination`,
          enabled: false,
          clickable: true,
        },
        navigation: {
          nextEl: `#${cID} .swiper-button-next`,
          prevEl: `#${cID} .swiper-button-prev`,
          enabled: false,
        },
        scrollbar: {
          el: `#${cID} .swiper-scrollbar`,
          hide: false,
          draggable: true,
          dragSize: 100,
        },
        breakpoints: {
          768: {
            navigation: {
              enabled: true,
            },
            //spaceBetween: 30,
          },
          scrollbar: {
            hide: true,
          },
        },
        on: {
          afterInit: function () {
            swiperContainer.classList.add("slider-init");
            checkScrollbarVisibility(this, swiperContainer);
            const swiperElement = this.el;
            const nextButton = swiperContainer.querySelector(
              ".swiper-button-next"
            );
            const tabindexValue = nextButton.getAttribute("tabindex");
            if (tabindexValue == -1) {
              swiperElement.classList.add("reachEnd");
            } else {
              swiperElement.classList.remove("reachEnd");
            }
          },
        },
      });
    } else if (
      swiperContainer.classList.contains("certificates-slider__container")
    ) {
      tlSlider = new Swiper("#" + id, {
        modules: [Navigation, Keyboard, A11y, Pagination, Scrollbar],
        keyboard: { enabled: true },
        a11y: { enabled: true },
        slidesPerView: 1.6,
        spaceBetween: 20,
        pagination: {
          el: `#${cID} .swiper-pagination`,
          enabled: false,
          clickable: true,
        },
        navigation: {
          nextEl: `#${cID} .swiper-button-next`,
          prevEl: `#${cID} .swiper-button-prev`,
          enabled: false,
        },
        scrollbar: {
          el: `#${cID} .swiper-scrollbar`,
          hide: false,
          draggable: true,
          dragSize: 100,
        },
        breakpoints: {
          576: {
            slidesPerView: 1.8,
            spaceBetween: 20,
          },
          768: {
            navigation: {
              enabled: true,
            },
            slidesPerView: 2,
            spaceBetween: 30,
          },
          992: {
            navigation: {
              enabled: true,
            },
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
        on: {
          afterInit: function () {
            swiperContainer.classList.add("slider-init");
            checkScrollbarVisibility(this, swiperContainer);
            const swiperElement = this.el;
            const nextButton = swiperContainer.querySelector(
              ".swiper-button-next"
            );
            const tabindexValue = nextButton.getAttribute("tabindex");
            if (tabindexValue == -1) {
              swiperElement.classList.add("reachEnd");
            } else {
              swiperElement.classList.remove("reachEnd");
            }
          },
          progress: function () {
            const swiperElement = this.el;
            const nextButton = swiperContainer.querySelector(
              ".swiper-button-next"
            );
            const tabindexValue = nextButton.getAttribute("tabindex");
            if (tabindexValue == -1) {
              swiperElement.classList.add("reachEnd");
            } else {
              swiperElement.classList.remove("reachEnd");
            }
          },
        },
      });
    } else if (
      swiperContainer.classList.contains("ce_image_teaser_slider_wide")
    ) {
      tlSlider = new Swiper("#" + id, {
        modules: [Navigation, Keyboard, A11y, Pagination, Scrollbar],
        keyboard: { enabled: true },
        a11y: { enabled: true },
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: `#${cID} .swiper-pagination`,
          enabled: false,
          clickable: true,
        },
        navigation: {
          nextEl: `#${cID} .swiper-button-next`,
          prevEl: `#${cID} .swiper-button-prev`,
          enabled: true,
        },
        scrollbar: {
          el: `#${cID} .swiper-scrollbar`,
          hide: false,
          draggable: true,
          dragSize: 100,
        },
        // breakpoints: {
        //   480: {
        //     slidesPerView: 1.105,
        //     spaceBetween: 20,
        //   },
        //   768: {
        //     navigation: {
        //       enabled: true
        //     },
        //     slidesPerView: 1.6,
        //     spaceBetween: 30,
        //   },
        //   992: {
        //     navigation: {
        //       enabled: true
        //     },
        //     slidesPerView: 2,
        //     spaceBetween: 30,
        //   }
        // },
        on: {
          afterInit: function () {
            swiperContainer.classList.add("slider-init");
            checkScrollbarVisibility(this, swiperContainer);
            const swiperElement = this.el;
            const nextButton = swiperContainer.querySelector(
              ".swiper-button-next"
            );
            const tabindexValue = nextButton.getAttribute("tabindex");
            if (tabindexValue == -1) {
              swiperElement.classList.add("reachEnd");
            } else {
              swiperElement.classList.remove("reachEnd");
            }
          },
          progress: function () {
            const swiperElement = this.el;
            const nextButton = swiperContainer.querySelector(
              ".swiper-button-next"
            );
            const tabindexValue = nextButton.getAttribute("tabindex");
            if (tabindexValue == -1) {
              swiperElement.classList.add("reachEnd");
            } else {
              swiperElement.classList.remove("reachEnd");
            }
          },
        },
      });
    } else if (swiperContainer.classList.contains("ce_header_image_slider")) {
      tlSlider = new Swiper("#" + id, {
        modules: [Navigation, Keyboard, A11y, Pagination, Scrollbar],
        keyboard: { enabled: true },
        a11y: { enabled: true },
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: { enabled: false },
        navigation: {
          nextEl: `#${cID} .swiper-button-next`,
          prevEl: `#${cID} .swiper-button-prev`,
          enabled: true,
        },
        scrollbar: {
          el: `#${cID} .swiper-scrollbar`,
          enabled: true,
          hide: false,
          draggable: true,
          dragSize: 100,
        },
        on: {
          afterInit: function () {
            swiperContainer.classList.add("slider-init");
          },
        },
      });
    } else {
      tlSlider = new Swiper("#" + id, {
        modules: [Navigation, Keyboard, A11y, Pagination, Scrollbar],
        keyboard: { enabled: true },
        a11y: { enabled: true },
        slidesPerView: 1.1,
        spaceBetween: 20,
        pagination: {
          el: `#${cID} .swiper-pagination`,
          enabled: false,
          clickable: true,
        },
        navigation: {
          nextEl: `#${cID} .swiper-button-next`,
          prevEl: `#${cID} .swiper-button-prev`,
          enabled: false,
        },
        scrollbar: {
          el: `#${cID} .swiper-scrollbar`,
          hide: false,
          draggable: true,
          dragSize: 100,
        },
        breakpoints: {
          480: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            navigation: {
              enabled: true,
            },
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1400: {
            navigation: {
              enabled: true,
            },
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
        on: {
          afterInit: function () {
            swiperContainer.classList.add("slider-init");
            checkScrollbarVisibility(this, swiperContainer);
            const swiperElement = this.el;
            const nextButton = swiperContainer.querySelector(
              ".swiper-button-next"
            );
            const tabindexValue = nextButton.getAttribute("tabindex");
            if (tabindexValue == -1) {
              swiperElement.classList.add("reachEnd");
            } else {
              swiperElement.classList.remove("reachEnd");
            }
          },
          progress: function () {
            const swiperElement = this.el;
            const nextButton = swiperContainer.querySelector(
              ".swiper-button-next"
            );
            const tabindexValue = nextButton.getAttribute("tabindex");
            if (tabindexValue == -1) {
              swiperElement.classList.add("reachEnd");
            } else {
              swiperElement.classList.remove("reachEnd");
            }
          },
        },
      });
    }

    function checkScrollbarVisibility(swiper, container) {
      if (swiper.params.slidesPerView < swiper.slides.length) {
        container.classList.add("scrollbar-show");
      } else {
        container.classList.remove("scrollbar-show");
      }
    }

    window.addEventListener("resize", function () {
      const swiperContainer = document.querySelector("#" + cID);
      checkScrollbarVisibility(tlSlider, swiperContainer);
    });
  });
};
